<template lang="html">
  <footer class="uk-container uk-container-small uk-flex uk-flex-wrap uk-margin-top uk-margin-bottom">
    <div class="uk-width uk-text-center" v-text="config.footer_text">
      {{ config.footer_text }}
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    config () {
      return this.$parent.config
    }
  }
}
</script>

<style lang="sass" scoped>

  footer
    font-weight: 200
    font-size: 12px
    text-align: justify

    @media screen and (max-width: 960px)
      > div
        text-align: center
        margin: 10px

</style>



// WEBPACK FOOTER //
// footer.vue?891e8130